import * as React from "react";
function SvgIcFileCode(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.155 4v.017L5.024 9.703H5v10.88h13.519V4H9.155zm.003 1.29V9.7H5.953l3.205-4.41zM5.75 19.833h12.019V4.75H9.905v5.703H5.75v9.38z"
        fill="currentColor"
      />
      <path
        d="M6.805 15.577l2.893 1.789v-.925l-2.214-1.195 2.214-1.218v-.926l-2.893 1.785v.69zM13.007 11.414h-.56l-2.15 7.465h.563l2.147-7.465zM16.716 14.878l-3.02-1.784v.897l2.337 1.223-2.338 1.237v.907l3.021-1.79v-.69z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcFileCode;
